// 评论item
<template>
  <div class="co-comment-view" @mouseover="changeCommentBtnStatus(true)" @mouseout="changeCommentBtnStatus(false)">
    <el-avatar :size="60" :src="item.headPortrait || defImage('head')"></el-avatar>
    <div class="comment-info-view">
      <div class="comment-top-view">
        <span class="user-text">{{item.commentName}}</span>
        <span class="info-text" v-if="item.receiveCommentName"> {{$t('reply')}} </span>
        <span class="user-text" v-if="item.receiveCommentName">{{item.receiveCommentName}}</span>
        <span class="info-text">: {{item.commentContent}}</span>
      </div>
      <div class="comment-bottom-view">
        <span>{{item.commentTime  | formatDate('all')}}</span>
        <transition name="el-fade-in-linear">
          <el-button v-show="showCommentBtn" type="text" class="co-comment-btn" @click="clickComment"><i class="iconfont iconhuifu"></i></el-button>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
   props:{
     // 评论数据
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      showCommentBtn: false,
      showComment: false
    }
  },
  computed: {
    ...mapGetters(['subjectType', 'info'])
  },
  methods:{
    condition(item) {
      let c = this.subjectType == 'ACTOR' && item.commentSubjectId != this.info['exhibitorEmployee']['exhibitorId']
      let c2 = this.subjectType == 'VISITOR' && item.commentSubjectId != this.info['visitor']['id']
      return c || c2
    },
    changeCommentBtnStatus (status) {
      this.showCommentBtn = status;
    },
    clickComment () {
      this.showComment = !this.showComment;
      this.$emit("clickComment", this.showComment, this.item);
    }
  }
}
</script>
<style lang="stylus" scoped>
  .co-comment-view {
    display : flex;
    margin-top : 6px;
    .comment-header {
      
    }
    .comment-info-view {
      margin-left 8px;
      flex : 1;
      .comment-top-view {
        margin-top: 8px;
        >span {
          font-size:16px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
        }
        .user-text {
          color: $color-main;
        }
        .info-text {
          color: $color-black-65;
        }
      }
      .comment-bottom-view {
        margin-top 4px;
        >span {
          color: $color-black-45;
        }
      }
    }
  }
  .co-comment-btn {
    padding : 0px;
    >i {
      font-size 16px;
    }
  }
</style>
